import { useMemo } from "react";
export const useGoogleDirectionsLink = ({ lat, lng, placeId, }) => useMemo(() => {
    const url = new URL("https://www.google.com/maps/dir/?api=1");
    url.searchParams.set("destination", `${lat},${lng}`);
    if (placeId)
        url.searchParams.set("destination_place_id", placeId);
    return url.toString();
}, [lat, lng, placeId]);
